import React from 'react';
import { RenderModule } from 'holocron';
import NavLinks from '../NavLinks';

const ContentOnly = () => (
  <RenderModule moduleName="axp-page-wrapper">
    <div className="dls-container">
      <div className="container">
        <NavLinks />
        <div className="flex flex-column flex-justify-center flex-align-center pad-4">
          <h1 className="heading-6">Welcome to Loyalty</h1>
          <h2 className="heading-5">axp-loyalty-experience-root</h2>
          <h2 className="heading-5">page-wrapper</h2>
        </div>
      </div>
    </div>
  </RenderModule>
);

ContentOnly.propTypes = {};

export default ContentOnly;
